module.exports = __webpack_public_path__ + "img/social-mail.effc5807.svg";